import { useCallback, useMemo, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
    useGetUserSettings,
    useSaveUserSettings,
} from "./useFrappeDoctype";
import { getSavedSortOrder } from "../../utils/menuSettingsSortUtils";

export const useIndependentUserSortSettings = ({
    doctype,
    orderKey,
    legacyIndices,
    legacyEntryKey,
}) => {
    const queryKey = useMemo(
        () => ["GetUserSettings", doctype],
        [doctype]
    );
    const { data: settings } = useGetUserSettings({ doctype });
    const saveSettings = useSaveUserSettings();
    const queryClient = useQueryClient();
    const saveQueueRef = useRef(Promise.resolve());

    const savedOrder = useMemo(
        () =>
            getSavedSortOrder({
                settings,
                orderKey,
                legacyIndices,
                legacyEntryKey,
            }),
        [settings, orderKey, legacyIndices, legacyEntryKey]
    );

    const saveOrder = useCallback(
        (order) => {
            const previousSettings = queryClient.getQueryData(queryKey);
            const nextSettings = {
                ...(previousSettings || {}),
                [orderKey]: Array.isArray(order) ? order : [],
            };

            queryClient.setQueryData(queryKey, nextSettings);
            saveQueueRef.current = saveQueueRef.current
                .catch(() => undefined)
                .then(() =>
                    saveSettings.mutateAsync({
                        doctype,
                        user_settings: nextSettings,
                    })
                )
                .catch(() => {
                    if (queryClient.getQueryData(queryKey) === nextSettings) {
                        queryClient.setQueryData(queryKey, previousSettings);
                    }
                });
        },
        [doctype, orderKey, queryClient, queryKey, saveSettings]
    );

    return { savedOrder, saveOrder };
};
